import Banner from "@/components/pages/media/banner";
import Reading from "@/components/pages/media/reading-material";
import React from "react";
import Clients from "@/components/pages/media/clients";
import { QUERY_ALL_CLIENTS } from "@/framework/queries/clients";
import { getUrqlClient } from "@/lib/urql-client";
import { sanitize } from "@/framework/utils/sanitize";
import { QUERY_ALL_BLOGS_SELECTIVE } from "@/framework/queries/blogs";
import Seo from "@/utils/seo";
import { QUERY_ALL_INSTA_POSTS } from "@/framework/queries/instagram";
import { QUERY_ENDPOINTS } from "@/framework/utils/query-endpoints";

export default function Media({ clients, insta, press }) {
  const seo = {
    slug: "media",
    metaTitle: "Chalk Studio Media Coverage | Interior Design Features",
    metaDescription:
      "Explore Chalk Studio’s media mentions, awards, and press that spotlight their innovation and artistic leadership",
  };
  return (
    <>
      <Seo seo={seo} />
      <Banner insta={insta} />
      <Reading data={press} />
      <Clients clients={clients} />
    </>
  );
}

export async function getStaticProps({ params }) {
  const client = await getUrqlClient();
  let clients = null;
  let press = null;
  let insta = null;
  try {
    const { data } = await client.query(
      QUERY_ALL_CLIENTS,
      {
        start: 0,
        limit: 12,
        sort: ["order:asc"],
        filters: {},
      },
      {
        requestPolicy: "network-only",
      }
    );

    const pressResponse = await client.query(
      QUERY_ENDPOINTS.QUERY_ALL_PRESS,
      {
        start: 0,
        limit: 50,
        sortBy: ["id:asc"],
        filter: {},
      },
      {
        requestPolicy: "network-only",
      }
    );
    const instagram = await client.query(
      QUERY_ALL_INSTA_POSTS,
      {
        start: 0,
        limit: 20,
        sort: ["id:desc"],
        filters: {},
      },
      {
        requestPolicy: "network-only",
      }
    );
    press = pressResponse.data?.presses?.data.map((row) => sanitize(row)) || [];
    clients = data?.clients?.data.map((row) => sanitize(row)) || [];
    insta = instagram?.data?.instagrams?.data.map((row) => sanitize(row)) || [];
  } catch (err) {
    console.log(err);
  }
  return {
    props: {
      press: press ?? {},
      clients: clients ?? {},
      insta: insta ?? {},
    },
    revalidate: 1, // In seconds
  };
}
